export default "__VITE_ASSET__CRCOj5sd__"